<template>
  <div>
    <!--notif jadwal-->
    <v-card tile flat class="bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5">
            <h1 class="headline black--text"> <strong>Daftar</strong> Institusi LPD </h1>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header
          @search="onSearch"
          :btnFilter="true"
          :btnAdd="$allow('akun-admin-program-lpd.create')"
          :btnDownload="$allow('lpd.download') || $allow(`lpd.download-laporan`)"
          @add="onAdd"
          @reload="onReload"
          @filter="onFilter"
          @download="onDownload"
        >
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text">
              <b>{{ total }}</b> Institusi LPD
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="saveFilter"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col class="py-0" cols="12" md="4">
                      <v-list-item class="px-0" @click="onDetail(item)">
                        <v-list-item-avatar color="blue-grey darken-3">
                          <v-icon dark>mdi-office-building-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 mt-3">
                          <div class="body-1 black--text">
                            <strong>{{ $getDeepObj(item, 'instansi.data.nama') || '-' }}</strong>
                          </div>
                          <p class="caption black--text">
                            <span>ID Institusi: {{ $getDeepObj(item, 'instansi.data.instansi_id') || '-' }}</span>
                          </p>
                          <p class="caption black--text">
                            <span>{{ $getDeepObj(item, 'instansi.data.email') || '-' }}</span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Penanggung Jawab LPD / Kepala B/BGP</span>
                          <p>
                            <span>{{ $getDeepObj(item, 'nama_penanggung_jawab') || '-' }}</span
                            ><br />
                            <span class="grey--text">{{ $getDeepObj(item, 'telp_penanggung_jawab') || '-' }}</span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Pelaksanaan Diklat</span>
                          <div>
                            <v-chip
                              v-if="item.is_diklat_daring === 0 && item.is_diklat_luring === 0"
                              label
                              small
                              class="orange lighten-4 black--text"
                            >
                              Belum Melaksanakan
                            </v-chip>
                            <v-chip v-if="item.is_diklat_daring" label small class="blue lighten-4 blue--text mb-1">
                              Diklat Daring
                            </v-chip>
                            <v-chip v-if="item.is_diklat_luring" label small class="green lighten-4 green--text">
                              Diklat Luring
                            </v-chip>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <span class="caption">Jumlah Admin</span>
                          <div>
                            Admin Program :
                            <span class="text-bold">{{ $getDeepObj(item, 'jml_admin_program') || 0 }}</span>
                          </div>
                          <div>
                            Operator : <span class="text-bold">{{ $getDeepObj(item, 'jml_operator') || 0 }}</span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Status</span>
                          <div>
                            <v-chip :color="+item.is_aktif === 1 ? 'success' : 'red'" dark small>
                              {{ +item.is_aktif === 1 ? 'Aktif' : 'Tidak Aktif' }}
                            </v-chip>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      colorBtn="primary"
      generalError
      :title="formulir.title"
      :useSave="formulir.useSave"
      @save="onSave"
    >
      <form-lpd
        ref="formulir"
        :isEdit="formulir.isEdit"
        :initValue="formulir.init"
        :errorEmail="formulir.errorEmail"
        :masters="masters"
        @onValidate="onValidate"
        @onBack="onBack"
      />
    </base-modal-full>
    <Akun ref="akun" :akun="akun" />
    <Detail ref="detail" :masters="masters" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import FormLpd from '../formulir/Lpd';
import Akun from '@components/cetak/Akun';
import Detail from '../formulir/Detail.vue';
import mixin from './mixin';
import list from '@mixins/list';
import actions from './actions';
import { M_AKTIF } from '@utils/master';
export default {
  mixins: [list, mixin],
  components: { FormLpd, Akun, Detail },
  data() {
    return {
      formulir: {},
      actions: actions,
      akun: {},
      groups: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    configs() {
      const M_PROPINSI = this.masters.m_propinsi || {};
      const M_KOTA = this.masters.m_kota || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 12 }, { cols: 12 }],
        disabled: [],
      };
    },

    formFilter() {
      return [
        {
          label: 'Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Pilih Status',
          default: true,
          type: 'checkbox',
          model: 'is_aktif',
          master: M_AKTIF,
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Pilih Jenis Diklat',
          default: true,
          type: 'select',
          model: 'k_diklat_paud',
          master: [
            { text: 'Melaksanakan Diklat Daring', value: 1 },
            { text: 'Melaksanakan Diklat Luring', value: 2 },
          ],
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Status UPT',
          default: true,
          type: 'select',
          model: 'is_upt',
          master: [
            { text: 'LPD Dari UPT', value: '1' },
            { text: 'LPD Non UPT', value: '0' },
          ],
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        },
      ];
    },

    filtersMaster() {
      const mAktif = {};
      M_AKTIF.forEach((item) => {
        this.$set(mAktif, item.value, item.text);
      });

      return {
        k_propinsi: this.masters && this.masters.m_propinsi,
        k_kota: this.masters && this.masters.m_kota,
        is_aktif: mAktif,
        k_diklat_paud: {
          1: 'Melaksanakan Diklat Daring',
          2: 'Melaksanakan Diklat Luring',
        },
        is_upt: {
          1: 'LPD Dari UPT',
          0: 'LPD Non UPT',
        },
      };
    },
  },
  created() {
    this.getMasters({
      name: ['m_propinsi', 'm_kota', 'm_lpd_paud'].join(';'),
      filter: {
        0: {
          k_propinsi: {
            op: '<',
            val: 90,
          },
        },
      },
    });
  },
  methods: {
    allow(action, data) {
      let disabled = false;
      switch (action.event) {
        case 'onAktif':
          disabled = !Number(this.$getDeepObj(data, 'is_aktif') || 0);
          break;
        case 'onNonAktif':
          disabled = Number(this.$getDeepObj(data, 'is_aktif') || 0);
          break;
        case 'onDelete':
          disabled =
            Number(this.$getDeepObj(data, 'is_diklat_daring') || 0) === 0 &&
            Number(this.$getDeepObj(data, 'is_diklat_luring') || 0) === 0 &&
            this.$allow('lpd.delete');
          break;
        default:
          disabled = this.$allow(action.akses, data.policies);
          break;
      }
      return disabled;
    },

    saveFilter(filters) {
      this.$delete(filters, 'is_diklat_daring');
      this.$delete(filters, 'is_diklat_luring');
      if (filters && filters.k_diklat_paud && filters.k_diklat_paud.length) {
        filters.k_diklat_paud.forEach((key) => {
          if (Number(key) === 1) {
            this.$set(filters, 'is_diklat_daring', 1);
          } else {
            this.$set(filters, 'is_diklat_luring', 1);
          }
        });
      }
      // set filter
      this.filters = filters;
      Object.assign(this.params, { page: 1 });
      this.fetchData();
      this.$refs.filter.close();
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #ffab91;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
